import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Input from 'components/common/Input';
import IconButton from 'components/common/IconButton';
import { isIterableArray } from 'helpers/utils';

const customStyles = {
 groupHeading: base => ({
  ...base,
  textAlign: 'right', // Alinear el texto a la derecha
  color: '#ff6347' // Cambiar el color del texto (puedes ajustar el color según tus preferencias)
  //   backgroundColor: '#f2f2f2'
 })
};

const indications = [
 {
  name: 'tag',
  title: 'ETIQUETA',
  body: `Establezca un monbre a la configuracion del financiamiento, el cual debera especificar en el excel en cada producto en el que desee tal configuracion y asi en el momento de la separacion este parametrizada con dicha configuracion.`
 },
 {
  name: 'quantity',
  title: 'CANTIDAD',
  body: `Establezca un porcentage que represente el valor de la cuota inicial de cada producto en el proyecto. El pocentage que se pretenda establecer debe ser dividido entre 100 ejp: 50% = 0.5%`
 },
 {
  name: 'status',
  title: 'ESTADO',
  body: `Establezca un numero de cuotas en la que podra definir el pago de la cuota inicial en una orden. El numero de cuotas representan el numero de meses que tardara un cliente en pagar el monto prestablecido.`
 },
 {
  name: 'stock',
  title: 'STOCK',
  body: `Establezca un numero de cuotas en la que podra definir el pago total de un producto, tenga en cuenta que en este numero se incluyen las cuotas que se hallan establecido en la cuota inicial. El numero de cuotas representan el numero de meses que tardara un cliente en pagar el monto prestablecido.`
 },
 {
  name: 'description',
  title: 'DESCRIPCION',
  body: `Establezca un monto minimo para cada cuota que se establezca, si el numero de la finaciacion afecta el monto minimo de las cuotas este se cambiara ala financiiacion mas cercano que cumpla con la cuota minima.`
 }
];

const defaultValues = {
 references: [],
 tag: null,
 quantity: null,
 status: null,
 stock: null,
 description: null
};

const SubProductForm = ({ product, options, append, update, fields, setOpen }) => {
 const {
  reset,
  watch,
  register,
  setValue,
  handleSubmit,
  formState: { errors }
 } = useForm({ defaultValues });

 const references = watch('references');

 const [selectRef, setSelectRef] = useState([]);

 useEffect(() => {
  reset({ ...defaultValues, ...product });
 }, [product]);

 useEffect(() => {
  setSelectRef(options.flatMap(group => group.options).filter(a => references.some(u => u === a.value)) ?? []);
 }, [references]);

 const handleChange = selectedOption => {
  const selectedGroups = options.reduce((acc, group) => {
   const selectedInGroup = selectedOption.filter(option => group.options.some(groupOption => groupOption.value === option.value));
   if (selectedInGroup.length > 0) {
    acc[group.label] = selectedInGroup.find(e => !selectRef.some(a => a.value === e.value)) ?? selectedInGroup[0];
   }
   return acc;
  }, {});

  const values = Object.values(selectedGroups).map(e => e.value);
  setValue('references', values, { shouldValidate: true });
 };

 const onSubmitData = newD => {
  const { index, ...newData } = newD;

  if (index >= 0) update(index, newData);
  else append(newData);

  return reset(defaultValues);
 };

 const onError = err => console.log('se genero un error en el formulario', err);

 return (
  <>
   <Row className="g-2 mt-3">
    <Input
     type="selectMulti"
     name="references"
     errors={errors}
     placeholder="Seleccione ref..."
     options={options}
     formGroupProps={{ className: 'col-12' }}
     formControlProps={{
      name: 'references',
      styles: customStyles,
      isClearable: true,
      isMulti: true,
      closeMenuOnSelect: true,
      value: selectRef,
      onChange: handleChange
     }}
    />

    <Input
     type="hidden"
     formControlProps={{
      ...register('references', {
       required: 'Debe seleccionar una referencia al menos',
       validate: value => isIterableArray(value) || 'Debe seleccionar al menos 1 referencia'
      })
     }}
    />

    <Input
     type="text"
     name="tag"
     label="etiqueta"
     errors={errors}
     placeholder="Etiqueta"
     help={indications.find(e => e.name === 'tag')}
     formGroupProps={{ className: 'col-8 col-md-4' }}
     formLabelProps={{ className: 'mb-0 px-1 fs--1 d-flex justify-content-between align-items-center flex-nowrap' }}
     formControlProps={{
      ...register('tag', {
       required: 'Campo requerido',
       minLength: { value: 3, message: 'pocos caracteres' },
       validate: value => {
        const uno = !/^[^A-Za-z0-9_\-\s]*$/g.test(value) || 'caracteres invalidos';
        const dos = !fields?.some(e => e.tag === value && value !== product?.tag) || 'la etiqueta ya existe';
        return typeof uno === 'boolean' ? dos : uno;
       }
      }),
      className: 'text-center',
      autoComplete: 'off',
      maxLength: 20,
      size: 'sm'
     }}
    />

    <Input
     type="text"
     errors={errors}
     name="quantity"
     placeholder="Cantidad"
     label="ctd."
     help={indications.find(e => e.name === 'quantity')}
     formGroupProps={{ className: 'col-4 col-md-2' }}
     formLabelProps={{ className: 'mb-0 px-1 fs--1 d-flex justify-content-between align-items-center flex-nowrap' }}
     formControlProps={{
      ...register('quantity', {
       required: 'requerido',
       validate: value => (!isNaN(value) && parseFloat(value) > 0) || 'debe ser > 0'
      }),
      className: 'text-center',
      size: 'sm'
     }}
    />

    <Input
     type="select"
     name="status"
     label="estado"
     errors={errors}
     placeholder="Seleccione Estado"
     help={indications.find(e => e.name === 'status')}
     options={[
      { label: 'Disponible', value: '1' },
      { label: 'Inactivo', value: '4' }
     ]}
     formGroupProps={{ className: 'col-8 col-md-4' }}
     formLabelProps={{ className: 'mb-0 px-1 fs--1 d-flex justify-content-between align-items-center flex-nowrap' }}
     formControlProps={{
      ...register('status', { required: 'requerido' }),
      size: 'sm'
     }}
    />

    <Input
     type="text"
     errors={errors}
     name="stock"
     label="stock"
     placeholder="Stock"
     help={indications.find(e => e.name === 'stock')}
     formGroupProps={{ className: 'col-4 col-md-2' }}
     formLabelProps={{ className: 'mb-0 px-1 fs--1 d-flex justify-content-between align-items-center flex-nowrap' }}
     formControlProps={{
      ...register('stock', { validate: value => !isNaN(value) || 'debe ser nummero' }),
      className: 'text-center',
      autoComplete: 'off',
      size: 'sm'
     }}
    />

    <Input
     type="textarea"
     errors={errors}
     label="descripcion"
     name="description"
     placeholder="Descripcion (opcional)"
     help={indications.find(e => e.name === 'description')}
     formGroupProps={{ className: 'col-12' }}
     formLabelProps={{ className: 'mb-0 px-1 fs--1 d-flex justify-content-between align-items-center flex-nowrap' }}
     formControlProps={{
      ...register('description'),
      autoComplete: 'off',
      size: 'sm',
      rows: 2
     }}
    />
   </Row>

   <IconButton
    size="sm"
    icon={product?.index >= 0 ? 'redo-alt' : 'plus'}
    transform="shrink-3"
    className="float-end mt-3"
    variant="falcon-success"
    onClick={() => handleSubmit(onSubmitData, onError)()}
   >
    {product?.index >= 0 ? 'Actualizar' : 'Crear'}
   </IconButton>

   <IconButton
    type="button"
    size="sm"
    icon="eye-slash"
    transform="shrink-3"
    className="mt-3 me-3"
    variant="falcon-default"
    onClick={() => {
     setOpen(false);
     const element = document.getElementById('listFnc');
     if (element) element.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }}
   />

   <IconButton
    type="reset"
    size="sm"
    icon="ban"
    transform="shrink-3"
    className="mt-3"
    variant="falcon-danger"
    onClick={() => reset(defaultValues)}
   >
    Cancelar
   </IconButton>
  </>
 );
};

SubProductForm.propTypes = {
 product: PropTypes.object,
 options: PropTypes.array,
 fields: PropTypes.array,
 append: PropTypes.func,
 update: PropTypes.func,
 setOpen: PropTypes.func
};

SubProductForm.defaultProps = { product: {} };

export default SubProductForm;
